import React from 'react';
import PropTypes from 'prop-types';
import { Icons, Button } from 'sarsaparilla';

export function Expander({ expanded, visible, onChange, screenReaderText, isLoading }) {
  const size = 'lg';

  if (!visible) {
    return <div className="spacer-for-no-expander" />;
  }

  let icon = <Icons.IconArrowRight size={size} />;

  if (expanded) {
    icon = <Icons.IconArrowDown size={size} />;
  }

  return (
    <Button
      size="xxs"
      className="expander-button"
      appearance="subtle"
      isLoading={isLoading}
      onClick={onChange}
      iconBeforeElement={icon}
      screenReaderTextBefore={screenReaderText}
    />
  );
}

Expander.propTypes = {
  expanded: PropTypes.bool,
  visible: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
  screenReaderText: PropTypes.string,
};
